<template>
  <el-dialog
    :visible="true"
    title="客户为什么要退保"
    width="600px"
    append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    @close="close"
    >
    <div class="hnm" ref="refHnm">
      <WatermarkCommon>
        <el-form
          class="hnm-form"
          ref="refForm"
          :model="ruleForm"
          :rules="rules"
          status-icon
          label-width="120px"
          autocomplete="off" >
          <el-form-item label="退保原因" prop="reasonForSurrender">
            <el-select 
              v-model="ruleForm.reasonForSurrender" 
              filterable 
              clearable
              style="width:100%;">
            <el-option v-for="item in reasonForSurrenderOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          </el-form-item>
          <el-form-item label="其它退保原因" prop="remark" v-if="ruleForm.reasonForSurrender === 4">
            <el-input 
              v-model.trim="ruleForm.remark" 
              type="textarea"
              placeholder="请输入退保原因"
              :autosize="{ minRows: 3 }"
              show-word-limit
              :maxlength="100" />
          </el-form-item>

          <div class="hnm-form-footer">
            <el-button class="submit-btn" size="large" @click="close">取消</el-button>
            <el-button
              :loading="loading['customer/updateCallRecord']"
              class="submit-btn"
              type="primary"
              size="large"
              @click="onSubmit"
              >提交</el-button>
          </div>
        </el-form>
      </WatermarkCommon>
    </div>
  </el-dialog>
</template>

<script>
import { Message } from 'element-ui';
import { mapState } from "vuex";
import { debounce } from '@/utils/base';

export default {
  props: {
    // initData: {type: Object, default: () => ({})},  //初始数据
    callId: String,
  },
  data(){
    const ruleForm = {
      ...this.initState(),
      // ...this.initData,
    };

    return {
      ruleForm,
      rules: {
        reasonForSurrender: [{required: true, message: '退保原因不能为空' }],
        remark: [{required: true, message: '其它退保原因不能为空' }],
      },
      // 退保原因选项
      reasonForSurrenderOptions: [
        {value: 1, label: '费用问题'},
        {value: 2, label: '保障不合适'},
        {value: 3, label: '认为是社保等误导'},
        {value: 4, label: '其他'},
      ],
    }
  },
  computed: {
    ...mapState('loading', {loading: 'effects'}),
  },
  created(){
  },
  mounted() {
  },

  methods: {
    initState(){
      return {
        reasonForSurrender: '',  //退保原因
        remark: '', //其它退保原因
      }
    },

    // 提交
    onSubmit(){
      this.onSubmitDebounce(this);
    },
    onSubmitDebounce: debounce((ctx) => {
      const refForm = ctx.$refs.refForm;
      if (!refForm) return;

      const {ruleForm, callId} = ctx;
      const {reasonForSurrender} = ruleForm;
      console.log('form-submit =>', {...ruleForm});

      refForm?.validate((valid, fields) => {
        if (valid) {
          const payload = {
            reasonForSurrender,
          };
          if (reasonForSurrender === 4) payload.remark = ruleForm.remark;
          if (callId) payload.callId = callId;

          console.log('form-submit-payload =>', payload);
          ctx.$store.dispatch('customer/updateCallRecord', payload).then((res) => {
            if (res.code === '000000') {
              Message.success(`提交成功！`);
              ctx.$emit('onConfirm');
            }
          });
        } else {
          console.log('error submit!', fields);
        }
      });
    }, 500, true),
    close(){
      this.$emit('onClose')
    },
  },
  components: {
  }
}
</script>

<style scoped lang="scss">

</style>
